theme.headerSection = (function () {
  function header() {
    const opener = document.querySelector('.header__actions_btn--menu');
    const closer = document.querySelector('.offcanvas__close_btn');
    const drawer = document.querySelector('.offcanvas-header');
    if (!opener || !closer || !drawer || drawer.dataset.lumeruneMenuReady === 'true') return;
    drawer.dataset.lumeruneMenuReady = 'true';
    const body = document.body;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let previousOverflow = null;
    opener.setAttribute('aria-expanded', 'false');
    if (drawer.id) opener.setAttribute('aria-controls', drawer.id);
    drawer.inert = true;

    const focusDrawer = () => {
      if (drawer.classList.contains('open') &&
          (document.activeElement === drawer || !drawer.contains(document.activeElement))) {
        closer.focus({ preventScroll: true });
      }
    };

    const close = (restoreFocus = true) => {
      if (!drawer.classList.contains('open')) return;
      removeTrapFocus(null, drawer);
      drawer.classList.remove('open');
      drawer.inert = true;
      opener.setAttribute('aria-expanded', 'false');
      body.style.overflowY = previousOverflow;
      if (restoreFocus && opener.isConnected) opener.focus({ preventScroll: true });
    };

    opener.addEventListener('click', event => {
      event.preventDefault();
      if (drawer.classList.contains('open')) { close(); return; }
      previousOverflow = body.style.overflowY;
      drawer.inert = false;
      drawer.classList.add('open');
      opener.setAttribute('aria-expanded', 'true');
      body.style.overflowY = 'hidden';
      trapFocus(drawer, closer, { dynamic: true });
      window.requestAnimationFrame(focusDrawer);
    });
    drawer.addEventListener('transitionend', event => {
      if (event.target === drawer) focusDrawer();
    });
    closer.addEventListener('click', event => { event.preventDefault(); close(); });

    const setSubmenu = (list, expanded) => {
      const item = list.parentElement;
      const toggle = Array.from(item.children).find(child => child.classList.contains('offcanvas__sub_menu_toggle'));
      item.classList.toggle('active', expanded);
      toggle?.classList.toggle('active', expanded);
      toggle?.setAttribute('aria-expanded', String(expanded));
      list.getAnimations().forEach(animation => animation.cancel());
      list.style.display = expanded ? 'block' : 'none';
      list.style.removeProperty('height');
      list.style.removeProperty('overflow');
      list.style.removeProperty('transition-property');
      list.style.removeProperty('transition-duration');
      if (expanded && !reducedMotion.matches) {
        list.animate([{ opacity: 0, transform: 'translateY(-4px)' }, { opacity: 1, transform: 'translateY(0)' }], {
          duration: 160, easing: 'cubic-bezier(.22,.8,.3,1)'
        });
      }
      if (!expanded) list.querySelectorAll('.offcanvas__sub_menu').forEach(child => setSubmenu(child, false));
    };

    drawer.querySelectorAll('.offcanvas__sub_menu').forEach((list, index) => {
      const item = list.parentElement;
      let toggle = Array.from(item.children).find(child => child.classList.contains('offcanvas__sub_menu_toggle'));
      if (!toggle) {
        toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'offcanvas__sub_menu_toggle';
        item.appendChild(toggle);
      }
      if (!list.id) list.id = `lumerune-mobile-submenu-${index}`;
      toggle.setAttribute('aria-label', item.querySelector('a')?.textContent.trim() || 'Menu');
      toggle.setAttribute('aria-controls', list.id);
      toggle.setAttribute('aria-expanded', 'false');
      toggle.addEventListener('click', event => {
        event.preventDefault();
        const willOpen = !item.classList.contains('active');
        if (willOpen) {
          Array.from(item.parentElement.children).filter(sibling => sibling !== item && sibling.classList.contains('active'))
            .forEach(sibling => {
              const siblingList = Array.from(sibling.children).find(child => child.classList.contains('offcanvas__sub_menu'));
              if (siblingList) setSubmenu(siblingList, false);
            });
        }
        setSubmenu(list, willOpen);
      });
    });

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && drawer.classList.contains('open')) {
        event.preventDefault();
        close();
      }
    });
    document.addEventListener('click', event => {
      if (!drawer.contains(event.target) && !opener.contains(event.target)) close(false);
    });
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 992) close(false);
    }, { passive: true });
  }
  return header;
})();
